import * as __mod_react from "react";
import * as __mod_react_dom from "react-dom";
import * as __mod_jsx from "react/jsx-runtime";
import * as __mod_rrd from "react-router-dom";
var require = (m) => {
  var __mods = {
    "react": __mod_react,
    "react-dom": __mod_react_dom,
    "react/jsx-runtime": __mod_jsx,
    "react-router-dom": __mod_rrd,
  };
  if (__mods[m]) return __mods[m];
  throw new Error("Cannot require " + m);
};
import{useEffect as E,useRef as z,forwardRef as X}from"react";import{forwardRef as v,createElement as G}from"react";var P=e=>e.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),O=e=>e.replace(/^([A-Z])|[\s-_]+(\w)/g,(a,u,t)=>t?t.toUpperCase():u.toLowerCase()),w=e=>{let a=O(e);return a.charAt(0).toUpperCase()+a.slice(1)},L=(...e)=>e.filter((a,u,t)=>!!a&&a.trim()!==""&&t.indexOf(a)===u).join(" ").trim(),A=e=>{for(let a in e)if(a.startsWith("aria-")||a==="role"||a==="title")return!0};import{forwardRef as H,createElement as F}from"react";var B={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var M=H(({color:e="currentColor",size:a=24,strokeWidth:u=2,absoluteStrokeWidth:t,className:d="",children:o,iconNode:r,...l},x)=>F("svg",{ref:x,...B,width:a,height:a,stroke:e,strokeWidth:t?Number(u)*24/Number(a):u,className:L("lucide",d),...!o&&!A(l)&&{"aria-hidden":"true"},...l},[...r.map(([C,S])=>F(C,S)),...Array.isArray(o)?o:[o]]));var m=(e,a)=>{let u=v(({className:t,...d},o)=>G(M,{ref:o,iconNode:a,className:L(`lucide-${P(w(e))}`,`lucide-${e}`,t),...d}));return u.displayName=w(e),u};var V=[["path",{d:"M20 6 9 17l-5-5",key:"1gmf2c"}]],c=m("check",V);var W=[["path",{d:"M5 12h14",key:"1ays0h"}]],n=m("minus",W);import{jsx as i,jsxs as I}from"react/jsx-runtime";var N={xs:{box:"h-4 w-4",input:"h-4 w-4",icon:"h-2.5 w-2.5 stroke-[3]",label:"text-xs",caption:"text-xs"},sm:{box:"h-5 w-5",input:"h-5 w-5",icon:"h-3.5 w-3.5 stroke-[3]",label:"text-sm",caption:"text-xs"},md:{box:"h-6 w-6",input:"h-6 w-6",icon:"h-4 w-4 stroke-[3]",label:"text-base",caption:"text-sm"},lg:{box:"h-8 w-8",input:"h-8 w-8",icon:"h-5 w-5 stroke-[2.5]",label:"text-xl",caption:"text-base"},xl:{box:"h-10 w-10",input:"h-10 w-10",icon:"h-6 w-6 stroke-[2.5]",label:"text-2xl",caption:"text-xl"}},D=X(({className:e="",containerClassName:a="",checked:u,indeterminate:t,label:d,caption:o,error:r,disabled:l,id:x,onChange:C,size:S="md",dark:h=!1,...R},q)=>{let T=z(null),p=q||T,k=x||`checkbox-${Math.random().toString(36).substr(2,9)}`;E(()=>{p.current&&(p.current.indeterminate=!!t)},[t,p]);let g=!!r,f=N[S],b=`flex ${f.box} shrink-0 items-center justify-center rounded border transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4B1F68] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50`,s=h?"border-[#575756] bg-transparent":"border-[#e4e4e2] bg-white";l?s="border-[#e4e4e2] bg-[#e4e4e2] text-[#8f8f8e]":g?(s="border-[#ff282f] bg-[#fff3f3]",(u||t)&&(s="border-[#ff282f] bg-[#ff282f] text-white shadow-[0_1px_3px_rgba(0,0,0,0.10)]")):u||t?s="border-[#4B1F68] bg-[#4B1F68] text-white shadow-[0_1px_3px_rgba(0,0,0,0.10)]":s+=" hover:border-[#4B1F68]";let y=l?"text-[#8f8f8e]":h?"text-white":"text-[#1d1d1d]",U=l||h?"text-[#8f8f8e]":"text-[#737372]";return I("div",{className:`flex items-center gap-3 ${a}`,children:[I("div",{className:"relative flex items-center",children:[i("input",{type:"checkbox",id:k,ref:p,className:`peer ${f.input} opacity-0 absolute inset-0 cursor-pointer disabled:cursor-not-allowed z-10`,checked:u,onChange:C,disabled:l,"aria-invalid":g,...R}),I("div",{className:`${b} ${s} ${e}`,children:[u&&!t&&i(c,{className:f.icon}),t&&i(n,{className:f.icon})]})]}),(d||o||typeof r=="string")&&I("div",{className:"grid gap-1.5 leading-none",children:[d&&i("label",{htmlFor:k,className:`${f.label} font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${y}`,style:{fontFamily:"Barlow, sans-serif"},children:d}),o&&!g&&i("p",{className:`${f.caption} ${U}`,style:{fontFamily:"Barlow, sans-serif"},children:o}),typeof r=="string"&&i("p",{className:`${f.caption} font-normal text-[#ff282f]`,style:{fontFamily:"Barlow, sans-serif"},children:r})]})]})});D.displayName="Checkbox";export{D as Checkbox};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/check.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/minus.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.522.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=index.js.map
